module.exports = __webpack_public_path__ + "img/pic_Taitung.521368ef.jpg";